import { Injectable } from '@angular/core';
import { Market, Role, SessionKey } from '@shared/clickar-constants';
import { UserDTO } from '@shared/model/user.model';
import { ApiService } from '@shared/services/api.service';
import { StorageManagerService } from '@shared/services/storage/storage-manager.service';
import { ClickarUtilsService } from '@shared/services/utils/clickar-utils.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
// import { UserProfile } from './users.model';

@Injectable()
export class UsersService {
	private static isReadingProfile = false;
	protected static profile = new Subject<UserDTO>();
	static profileState = UsersService.profile.asObservable();

	constructor(
		// private http: HttpClient,
		private apiService: ApiService,
		private storageService: StorageManagerService,
		private utils: ClickarUtilsService
	) { }

	getProfile(): Observable<UserDTO> {
		if (!UsersService.isReadingProfile) {
			UsersService.isReadingProfile = true;
			this.apiService.getUserUsingGET().subscribe(model => {
				// console.log('getProfileOfLoggedUser complete');
				if (model != null) {
					this.storageService.setSessionItem(SessionKey.USER_PROFILE, model);
					this.storageService.setSessionItem(SessionKey.USER_MARKET, model.idMarket);
					this.storageService.setSessionItem(SessionKey.USER_LANGUAGE,
						model.preferredLanguage === Market.MARKET_OTHER ?
							Market.MARKET_EN :
							model.preferredLanguage
					);

					this.storageService.setSessionItem(SessionKey.USER_ID, model.idUser);
					this.storageService.setSessionItem(SessionKey.DEALER_ID, model.idDealer);
					UsersService.profile.next(<UserDTO>model);
				}
				UsersService.isReadingProfile = true;
			}, () => {
				console.error('getProfile error');
				this.resetProfile();
				UsersService.profile.error('');
				UsersService.isReadingProfile = false;
			});
		}
		return UsersService.profileState;
	}

	resetProfile(): void {
		UsersService.isReadingProfile = false;
		this.storageService.removeSessionItem(SessionKey.USER_PROFILE);
		this.storageService.removeSessionItem(SessionKey.USER_MARKET);
		this.storageService.removeSessionItem(SessionKey.USER_ID);
		this.storageService.removeSessionItem(SessionKey.DEALER_ID);
	}

	logout(): Observable<any> {
		this.resetProfile();
		return null;
	}

	getProfileOfLoggedUser(force = false): Observable<UserDTO> {
		let model = null;
		if (!force && (model = this.storageService.getSessionItem(SessionKey.USER_PROFILE, null))) {

			// FIXME Timeout is a workaround to emit user after return
			window.setTimeout(() => {
				UsersService.profile.next(<UserDTO>model);
			}, 0);
		} else {
			this.getProfile();
		}
		return UsersService.profileState;
	}


	hasRole = (role: string): Observable<boolean> => this.getProfileOfLoggedUser().pipe(
		map(value => this.utils.hasRole(role, value.roles))
	);

	/* getUser = (username: string): Observable<UserProfile> => this.http.get<UserProfile>(`${environment.baseApiUrl}/bbusbe/services/underwriters/${username}`);

	getUsers(dataQuery: HttpParams, noSpin = false): Observable<UserProfile[]> {
		const headers = this.setSpinner(noSpin);
		return this.http.get<UserProfile[]>(`${environment.baseApiUrl}/bbusbe/services/underwriters`,
			{
				headers,
				params: dataQuery
			});
	}

	patchUser = (username: string, body: any): Observable<any> => this.http.patch(`${environment.baseApiUrl}/bbusbe/services/underwriters/${username}`, body, { responseType: 'text' });

	private setSpinner(noSpin: boolean): HttpHeaders {
		const _headers = {};
		if (noSpin) {
			_headers[HeaderKey.NO_SPIN] = `${noSpin}`;
		}
		return new HttpHeaders(_headers);
	} */

	isAdmin = (): Observable<boolean> => this.hasRole(Role.ADMIN);


	isCustomerCenter(): Observable<boolean> {
		console.log("CUSTOMER");
		return this.hasRole(Role.CUSTOMER_CENTER);
	}
}